import { render, staticRenderFns } from "./newQuote.vue?vue&type=template&id=01869c9b&"
import script from "./newQuote.vue?vue&type=script&lang=js&"
export * from "./newQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports